export function documentKind(file = {}) {
  const name = (file.name || '').toLowerCase();
  const url = (file.url || '').split('?')[0].split('#')[0].toLowerCase();
  const type = (file.type || '').toLowerCase();
  if (/\.docx$/.test(name) || /\.docx$/.test(url) || type.includes('wordprocessingml') || url.startsWith('data:application/vnd.openxmlformats-officedocument.wordprocessingml')) return 'docx';
  if (/\.doc$/.test(name) || /\.doc$/.test(url) || type === 'application/msword') return 'doc';
  if (/\.pdf$/.test(name) || /\.pdf$/.test(url) || type === 'application/pdf' || url.startsWith('data:application/pdf') || file.sourceType === 'query') return 'pdf';
  return 'unknown';
}

export const safeDocumentUrl = url => /^(https?:\/\/|blob:|\/[^/]|data:application\/(pdf|msword|vnd\.openxmlformats-officedocument\.wordprocessingml\.document);)/i.test(url || '') ? url : '';

export function inspectionFiles(data) {
  return (data?.attachments || []).map((attachment, index) => ({ ...attachment, index }))
    .filter(attachment => attachment.enabled !== false && safeDocumentUrl(attachment.file?.url));
}

export function certificateAttachment(inspection, legacyUrl) {
  const files = inspectionFiles(inspection);
  return files.find(item => item.index === inspection?.giCertificateIndex)
    || files.find(item => /GI|检测|检验|证书/i.test(item.name))
    || files[0]
    || (!inspection && safeDocumentUrl(legacyUrl) ? { name: 'GI 检测证书', file: { url: legacyUrl, name: 'GI 检测证书.pdf', type: 'application/pdf' } } : null);
}

export function getGIInspectionData(legacyUrl) {
  return { giCertificateIndex: 0, attachments: [{ enabled: true, name: 'GI 检测证书', sourceType: 'upload',
    file: safeDocumentUrl(legacyUrl) ? { name: 'GI 检测证书.pdf', type: 'application/pdf', url: legacyUrl, sourceType: 'upload' } : null }] };
}
